import * as React from "react";
import { Dropdown } from "react-bootstrap";

export class PartialPayModal extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      amount: "",
      loaderTrue: false,
    };
  }

  handleCancel() {
    this.props.onClose(false);
  }

  handleSave() {
    if (!this.state.amount || Number(this.state.amount) <= 0) return;

    this.setState({ loaderTrue: true });
    this.props.onClose(true, Number(this.state.amount));
  }

  render() {
    return (
      <div className="confirmModal">
        <div>
          <div className="title">Partial Payment</div>

          <div className="description">
            <input
              type="number"
              className="form-control"
              placeholder="Enter amount"
              value={this.state.amount}
              onChange={(e) =>
                this.setState({ amount: e.target.value })
              }
            />
          </div>

          <div className="action-link">
            <Dropdown.Item
              className="btn wht-bg"
              onClick={this.handleCancel.bind(this)}
            >
              Cancel
            </Dropdown.Item>

            <Dropdown.Item
              className="btn btn-danger"
              onClick={this.handleSave.bind(this)}
            >
              Save
            </Dropdown.Item>
          </div>
        </div>
      </div>
    );
  }
}
